import Comments from '@/components/comment/Comments';
const PDPComments = () => {
  return <Comments data-sentry-element="Comments" data-sentry-component="PDPComments" data-sentry-source-file="PDPComments.tsx" />;
};
export default PDPComments;